import {
  FillBlankComponent,
  LessonComponentResponseType
} from '../../../models/LessonComponent';
import React, { useEffect, useState } from 'react';

import { BlankResponse } from '../../../models/LessonComponentContent';
import { FillGapComponent } from './FillGapComponent';

interface IFillblankViewProps {
  component: FillBlankComponent;
  onChange: (response: LessonComponentResponseType) => void;
}

export default function FillBlankView(props: IFillblankViewProps) {
  const html = props.component?.content.text;

  const [answers, setAnswers] = useState<BlankResponse[]>(
    (props.component.answer && JSON.parse(props.component.answer)) || []
  );

  useEffect(() => {
    if (props.component.answer) {
      setAnswers(JSON.parse(props.component.answer));
    }
  }, [props.component.answer]);

  const onChange = (id: string, value: string) => {
    const copy = [...answers];
    const item = copy.find((ans) => ans.id === id);
    if (item) {
      item.answer = value;
    } else {
      copy.push({ id, answer: value });
    }
    setAnswers(copy);
    props.onChange(JSON.stringify(copy));
  };

  return (
    <FillGapComponent
      html={html}
      onChange={onChange}
      component={props.component}
      answers={answers}
    />
  );
}
